import dayjs, { Dayjs } from 'dayjs'
import { useState, VFC } from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import { CalendarIcon } from 'src/assets/svgs'
import { DatePicer } from 'src/components/DatePicker'
import { asModal, ModalProps } from 'src/components/hoc/asModal'
import { _messagebutton, _messagebuttonbg } from 'src/styles/colors'
import { flexCenter, inversing } from 'src/styles/mixins'
import styled from 'styled-components'
import { formatScheduledTime } from '../utils'
import { Button, ButtonsDiv, CancelButton, Layout } from './styles'

type ScheduleMessageProps = {
  scheduledAt?: Dayjs
  setScheduledAt: (at: Dayjs | undefined) => void
}
const ScheduleMessage: VFC<ModalProps<ScheduleMessageProps>> = ({
  close,
  ...props
}) => {
  const [scheduledAt, setScheduledAt] = useState(props.scheduledAt)
  const [isOpen, setIsOpen] = useState(false)
  return (
    <StyledLayout>
      <h3>送信時刻を指定して予約送信</h3>
      <p>
        {
          '送信時刻を指定してメッセージの送信を行うことができます。\n送信時刻になるまでメッセージは編集・送信取り消しができます。'
        }
      </p>
      <DatePickerDiv>
        <ScheduleButton onClick={() => setIsOpen(!isOpen)}>
          <CalendarIcon />
          {scheduledAt
            ? `${formatScheduledTime(scheduledAt)}に送信予約`
            : '日付と時間を選択してください'}
        </ScheduleButton>
        {isOpen && (
          <>
            <OuterDiv onClick={() => setIsOpen(false)} />
            <DatePicer
              selected={scheduledAt?.toDate()}
              onChange={(date) => date && setScheduledAt(dayjs(date as Date))}
              showTimeInput
              inline
              minDate={new Date()}
              locale="ja"
            />
          </>
        )}
      </DatePickerDiv>
      <ButtonsDiv>
        <CancelButton onClick={close}>キャンセル</CancelButton>
        <Button
          onClick={() => {
            props.setScheduledAt(scheduledAt)
            close()
          }}
        >
          送信時刻を確定
        </Button>
      </ButtonsDiv>
    </StyledLayout>
  )
}
export const ScheduleMessageModal = asModal(ScheduleMessage)
const OuterDiv = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`
const DatePickerDiv = styled.div`
  position: relative;
  .react-datepicker {
    position: absolute;
    top: 100%;
    left: 0;
  }
`

const ScheduleButton = styled(Button)`
  ${flexCenter};
  border: 1px solid ${_messagebuttonbg};
  padding: 16px 32px;
  font-size: 14px;
  ${inversing({ color: _messagebuttonbg, background: _messagebutton })}
  svg {
    margin-right: 8px;
  }
`

const StyledLayout = styled(Layout)`
  ${ScheduleButton} {
    margin-top: 24px;
  }
`
